import React from 'react';
import { connect } from 'react-redux';
import i18n from "../../../i18next";
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import MaterialIcon from 'material-icons-react';

import { enableDisableRestaurantInsight } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';

class RestaurantInsightOptions extends React.Component {

    state = {
        isEnableInsightModalOpen: false,
        isDisableInsightModalOpen: false,
    }

    toggleEnableModal = () => {
        this.setState({ isEnableInsightModalOpen: !this.state.isEnableInsightModalOpen })
    }

    toggleDisableModal = () => {
        this.setState({ isDisableInsightModalOpen: !this.state.isDisableInsightModalOpen })
    }

    enableInsights = () => {
        this.props.enableDisableRestaurantInsight(this.props.restaurantInsight.restaurantId, true)
        this.toggleEnableModal()
    }

    disableInsights = () => {
        this.props.enableDisableRestaurantInsight(this.props.restaurantInsight.restaurantId, false)
        this.toggleDisableModal()
    }

    renderEnableInsightModal() {

        return (
            <Modal isOpen={this.state.isEnableInsightModalOpen} toggle={this.toggleEnableModal} size="md">
                <ModalHeader className="modalHeader" toggle={this.toggleEnableModal}>{i18n.t('screens:restaurantInsightScreen.enableInsightModalTitle')}</ModalHeader>
                <ModalBody>
                    <h6 style={{ marginBottom: 15 }} >{i18n.t('screens:restaurantInsightScreen.enableInsightModalMessage')}</h6>
                    <Button
                        style={{ marginRight: 10, position: 'relative' }}
                        color="primary"
                        onClick={this.enableInsights}
                    >
                        {i18n.t('common:buttons.confirm')}
                    </Button>
                    <Button onClick={this.toggleEnableModal}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalBody>
            </Modal>
        );
    }

    renderDisableInsightModal() {

        return (
            <Modal isOpen={this.state.isDisableInsightModalOpen} toggle={this.toggleDisableModal} size="md">
                <ModalHeader className="modalHeader" toggle={this.toggleDisableModal}>{i18n.t('screens:restaurantInsightScreen.disableInsightModalTitle')}</ModalHeader>
                <ModalBody>
                    <h6 style={{ marginBottom: 15 }} >{i18n.t('screens:restaurantInsightScreen.disableInsightModalMessage')}</h6>
                    <Button
                        style={{ marginRight: 10, position: 'relative' }}
                        color="primary"
                        onClick={this.disableInsights}
                    >
                        {i18n.t('common:buttons.confirm')}
                    </Button>
                    <Button onClick={this.toggleDisableModal}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalBody>
            </Modal>
        );
    }

    renderAdditionalData = () => {

        const { paddingTop, errorMessage, buttonDiv } = styles;

        switch (this.props.restaurantInsight.status) {
            case 'DISABLED':
                return (
                    <div style={paddingTop}>
                        <Button color="primary" sm={12} onClick={this.toggleEnableModal} >
                            <MaterialIcon icon="add_circle_outline" color="#fff" size={18} /> {i18n.t('common:buttons.enable')}
                        </Button>
                    </div>
                );
            case 'PLANNED':
                return (
                    <div style={paddingTop}>
                        <div style={errorMessage}>
                            <div>
                                {i18n.t('screens:restaurantInsightScreen.migrationStartTime')} {this.props.restaurantInsight.migrationStartTime}
                            </div>
                            <div>
                                {i18n.t('screens:restaurantInsightScreen.migrationEndTime')} {this.props.restaurantInsight.migrationEndTime}
                            </div>
                        </div>
                        <div style={buttonDiv}>
                            <Button color="primary" sm={12} onClick={this.toggleDisableModal} >
                                <MaterialIcon icon="remove_circle_outline" color="#fff" size={18} /> {i18n.t('common:buttons.disable')}
                            </Button>
                        </div>
                    </div>
                );
            case 'IN_PROGRESS':
                return (
                    <div style={paddingTop}>
                        <div style={errorMessage}>
                            <div>
                                {i18n.t('screens:restaurantInsightScreen.migrationStartTime')} {this.props.restaurantInsight.migrationStartTime}
                            </div>
                            <div>
                                {i18n.t('screens:restaurantInsightScreen.migrationEndTime')} {this.props.restaurantInsight.migrationEndTime}
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }

    renderMessage = () => {
        switch (this.props.restaurantInsight.status) {
            case 'DISABLED':
                return i18n.t('screens:restaurantInsightScreen.restaurantInsightDisabledStatus');
            case 'PLANNED':
                return i18n.t('screens:restaurantInsightScreen.restaurantInsightPlannedStatus');
            case 'IN_PROGRESS':
                return i18n.t('screens:restaurantInsightScreen.restaurantInsighInProgressStatus');
            default:
                return null;
        }
    }

    render() {
        const { errorContainerStyle, errorMessage } = styles;

        return (
            <React.Fragment>
                <div style={errorContainerStyle} >
                    <h5 style={errorMessage}>{this.renderMessage()}</h5>
                    {this.renderAdditionalData()}
                </div>
                {this.renderEnableInsightModal()}
                {this.renderDisableInsightModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        restaurantInsight: state.restaurantInsight
    }
};

export default connect(mapStateToProps, { enableDisableRestaurantInsight })(RestaurantInsightOptions);

const styles = {
    errorContainerStyle: {
        marginTop: '25px',
        backgroundColor: '#fafafa',
        padding: '60px 10px 0 10px',
        height: 250,
        textAlign: 'center'
    },
    errorMessage: {
        color: "#c3c3c3"
    },
    paddingTop: {
        paddingTop: '15px'
    },
    buttonDiv: {
        paddingTop: '30px'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/restaurantInsight/RestaurantInsightOptions.js